import {
  Alert,
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography
} from '@mui/material';

import useStyles from './ContentNotification.styles';

const ContentNotification = ({
  title,
  text,
  severity = 'info'
}: {
  title: string;
  text: string;
  severity?: 'info' | 'warning' | 'error' | 'success';
}) => {
  const { classes } = useStyles();

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      className={classes.selectOrgContainer}
    >
      <Card>
        <CardHeader title={title} />
        <CardContent>
          <Alert severity={severity}>
            <Typography>{text}</Typography>
          </Alert>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ContentNotification;
